import React from 'react';
import { faNumber } from 'utils/common.util';
import fa from 'locales/fa.json';

const DiscountPrice: React.FC<{ price: number; discount: number }> = ({
  price,
  discount,
}) => {
  return (
    <span>
      {Number(price) !== 0 ? (
        <span className="flex">
          <span>{fa.global.tooman}</span>
          <span className="ml-2">
            {faNumber(Math.round(Number(price) * ((100 - discount) / 100)) / 1000)}
          </span>
          {discount !== 0 && (
            <span className="ml-3 line-through">{faNumber(Number(price) / 1000)}</span>
          )}
        </span>
      ) : (
        fa.global.free
      )}
    </span>
  );
};

export default DiscountPrice;
